module.exports = __webpack_public_path__ + "static/media/(H)_MG_4704_-_bijuterias.978573a0.jpg";